import { DoqFaceSvgProps } from '../types';

const DependencyMatrixError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#a)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-dependency-matrix-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#FCBF4C"
        mask="url(#bottom-mask-dependency-matrix-error)"
      />

      <mask
        id="mask0_9012_51922"
        width="320"
        height="320"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_9012_51922)">
        <path fill="#fff" d="M80 120h160v200H80z" />
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        fill="#2974C4"
        d="M142 184c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8ZM178 184c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8Z"
      />
      <g fill="#2974C4" opacity=".5">
        <path d="M88.252 238c-.1645.639-.252 1.309-.252 2v12.5h8V238h-7.748ZM88.3984 237.5H96V232c-3.5452 0-6.5518 2.306-7.6016 5.5ZM96.5 232v5.5H112V232H96.5ZM112.5 232v5.5H128V232h-15.5ZM128.5 232v5.5H144V232h-15.5ZM144.5 232v5.5H160V232h-15.5ZM160.5 232v5.5H176V232h-15.5ZM176.5 232v5.5H192V232h-15.5ZM192.5 232v5.5H208V232h-15.5ZM208.5 232v5.5H224V232h-15.5ZM224.5 232.015v5.485h7.102c-1-3.043-3.776-5.28-7.102-5.485ZM231.748 238H224.5v14.5h7.5V240c0-.691-.088-1.361-.252-2ZM232 253h-7.5v14.5h7.5V253ZM232 268h-7.5v14.5h7.5V268ZM232 283h-7.5v14.5h7.36c.092-.486.14-.987.14-1.5v-13ZM231.748 298H224.5v5.985c3.505-.217 6.4-2.69 7.248-5.985ZM224 304v-6h-15.5v6H224ZM208 304v-6h-15.5v6H208ZM192 304v-6h-15.5v6H192ZM176 304v-6h-15.5v6H176ZM160 304v-6h-15.5v6H160ZM144 304v-6h-15.5v6H144ZM128 304v-6h-15.5v6H128ZM112 304v-6H96.5v6H112ZM96 304v-6h-7.748c.8881 3.45 4.0203 6 7.748 6ZM88.1404 297.5H96V283h-8v13c0 .513.0482 1.014.1404 1.5ZM88 282.5h8V268h-8v14.5ZM88 267.5h8V253h-8v14.5ZM215 248.625l-3.125-3.125.881-.881 2.244 2.237 4.744-4.743.881.887-5.625 5.625Z" />
        <path
          fillRule="evenodd"
          d="M224 238h-15.5v14.5H224V238Zm-3.375 1.875h-8.75c-.694 0-1.25.563-1.25 1.25v8.75c0 .687.556 1.25 1.25 1.25h8.75c.694 0 1.25-.563 1.25-1.25v-8.75c0-.687-.556-1.25-1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M224 253h-15.5v14.5H224V253ZM211.875 275.5l3.125 3.125 5.625-5.625-.881-.888-4.744 4.744-2.244-2.237-.881.881Z" />
        <path
          fillRule="evenodd"
          d="M224 268h-15.5v14.5H224V268Zm-12.125 1.875h8.75c.694 0 1.25.563 1.25 1.25v8.75c0 .687-.556 1.25-1.25 1.25h-8.75c-.694 0-1.25-.563-1.25-1.25v-8.75c0-.687.556-1.25 1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M224 283h-15.5v14.5H224V283ZM208 283v14.5h-15.5V283H208ZM208 268v14.5h-15.5V268H208ZM196.125 260.5l3.125 3.125 5.625-5.625-.881-.888-4.744 4.744-2.244-2.237-.881.881Z" />
        <path
          fillRule="evenodd"
          d="M208 253v14.5h-15.5V253H208Zm-11.875 1.875h8.75c.694 0 1.25.563 1.25 1.25v8.75c0 .687-.556 1.25-1.25 1.25h-8.75c-.694 0-1.25-.563-1.25-1.25v-8.75c0-.687.556-1.25 1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M208 238v14.5h-15.5V238H208ZM192 238h-15.5v14.5H192V238ZM192 253h-15.5v14.5H192V253ZM192 268h-15.5v14.5H192V268ZM183.25 293.625l-3.125-3.125.881-.881 2.244 2.237 4.744-4.744.881.888-5.625 5.625Z" />
        <path
          fillRule="evenodd"
          d="M192 283h-15.5v14.5H192V283Zm-3.125 1.875h-8.75c-.694 0-1.25.563-1.25 1.25v8.75c0 .687.556 1.25 1.25 1.25h8.75c.694 0 1.25-.563 1.25-1.25v-8.75c0-.687-.556-1.25-1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M176 283v14.5h-15.5V283H176ZM176 268v14.5h-15.5V268H176ZM167.25 263.625l-3.125-3.125.881-.881 2.244 2.237 4.744-4.744.881.888-5.625 5.625Z" />
        <path
          fillRule="evenodd"
          d="M176 253v14.5h-15.5V253H176Zm-3.125 1.875h-8.75c-.694 0-1.25.563-1.25 1.25v8.75c0 .687.556 1.25 1.25 1.25h8.75c.694 0 1.25-.563 1.25-1.25v-8.75c0-.687-.556-1.25-1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M176 238v14.5h-15.5V238H176ZM160 238h-15.5v14.5H160V238ZM160 253h-15.5v14.5H160V253ZM160 268h-15.5v14.5H160V268ZM148.125 290.5l3.125 3.125 5.625-5.625-.881-.888-4.744 4.744-2.244-2.237-.881.881Z" />
        <path
          fillRule="evenodd"
          d="M160 283h-15.5v14.5H160V283Zm-11.875 1.875h8.75c.694 0 1.25.563 1.25 1.25v8.75c0 .687-.556 1.25-1.25 1.25h-8.75c-.694 0-1.25-.563-1.25-1.25v-8.75c0-.687.556-1.25 1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="m132.125 290.5 3.125 3.125 5.625-5.625-.881-.888-4.744 4.744-2.244-2.237-.881.881Z" />
        <path
          fillRule="evenodd"
          d="M144 283v14.5h-15.5V283H144Zm-11.875 1.875h8.75c.694 0 1.25.563 1.25 1.25v8.75c0 .687-.556 1.25-1.25 1.25h-8.75c-.694 0-1.25-.563-1.25-1.25v-8.75c0-.687.556-1.25 1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M144 268v14.5h-15.5V268H144ZM144 253v14.5h-15.5V253H144ZM144 238v14.5h-15.5V238H144ZM116.125 245.5l3.125 3.125 5.625-5.625-.881-.887-4.744 4.743-2.244-2.237-.881.881Z" />
        <path
          fillRule="evenodd"
          d="M128 238h-15.5v14.5H128V238Zm-11.875 1.875h8.75c.694 0 1.25.563 1.25 1.25v8.75c0 .687-.556 1.25-1.25 1.25h-8.75c-.694 0-1.25-.563-1.25-1.25v-8.75c0-.687.556-1.25 1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M128 253h-15.5v14.5H128V253ZM119.25 278.625l-3.125-3.125.881-.881 2.244 2.237 4.744-4.744.881.888-5.625 5.625Z" />
        <path
          fillRule="evenodd"
          d="M128 268h-15.5v14.5H128V268Zm-3.125 1.875h-8.75c-.694 0-1.25.563-1.25 1.25v8.75c0 .687.556 1.25 1.25 1.25h8.75c.694 0 1.25-.563 1.25-1.25v-8.75c0-.687-.556-1.25-1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M128 283h-15.5v14.5H128V283ZM102.75 248.625l-3.125-3.125.881-.881 2.244 2.237 4.744-4.743.881.887-5.625 5.625Z" />
        <path
          fillRule="evenodd"
          d="M96.5 252.5V238H112v14.5H96.5Zm11.875-12.625h-8.75c-.6938 0-1.25.563-1.25 1.25v8.75c0 .687.5562 1.25 1.25 1.25h8.75c.694 0 1.25-.563 1.25-1.25v-8.75c0-.687-.556-1.25-1.25-1.25Z"
          clipRule="evenodd"
        />
        <path d="M96.5 267.5V253H112v14.5H96.5ZM96.5 282.5V268H112v14.5H96.5ZM96.5 297.5V283H112v14.5H96.5Z" />
      </g>
      <path
        fill="#2974C4"
        fillRule="evenodd"
        d="M160.851 200.005c-1.035.077-1.851.941-1.851 1.995 0 1.105.895 2 2 2h14.5c1.933 0 3.5 1.567 3.5 3.5 0 .17-.012.337-.036.501H179c.001 1.104.896 1.999 2 1.999 1.105 0 2-.895 2-2 0-.058-.003-.116-.007-.174l-.009.175c.01-.166.016-.333.016-.501 0-4.142-3.358-7.5-7.5-7.5H161l-.149.005Z"
        clipRule="evenodd"
      />
      <path
        fill="#500052"
        d="M167.994 76.5c.902 0 1.632-.7165 1.632-1.5977 0-.8811-.732-1.5987-1.633-1.5976h-15.697c-.906 0-1.635.7176-1.635 1.5976 0 .8812.73 1.5977 1.635 1.5977h15.698ZM147.305 102.787h25.859c-5.637-9.794-5.525-24.2374-5.514-25.0879h-14.383c-1.113 18.454-5.203 24.1769-5.962 25.0879ZM138.68 113.649h42.698c.235-.889 1.035-5.1-4.747-5.491 0 0-1.877 0-2.694-3.79H146.07c.014.547-.101 3.298-3.49 3.854-3.666.612-4.029 3.182-3.9 5.427ZM184 116.666l-.041 3.333h-47.921L136 117.17c.589-1.29 1.831-1.883 2.017-1.965h44.257c1.167.381 1.726 1.461 1.726 1.461Z"
      />
      <path
        fill="#BB58BC"
        d="M160.252 73.5388c5.621 0 10.178-4.5978 10.178-10.2694C170.43 57.5978 165.873 53 160.252 53s-10.177 4.5978-10.177 10.2694c0 5.6716 4.556 10.2694 10.177 10.2694ZM139.5 113c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5h42c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5h-42ZM145 103.5c0-.828.672-1.5 1.5-1.5h27c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5h-27c-.828 0-1.5-.672-1.5-1.5ZM152.5 76c-.828 0-1.5.6716-1.5 1.5s.672 1.5 1.5 1.5h15c.828 0 1.5-.6716 1.5-1.5s-.672-1.5-1.5-1.5h-15Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h320v320H0z" />
      </clipPath>
    </defs>
  </svg>
);

export { DependencyMatrixError };
